module.exports = __webpack_public_path__ + "img/handshake.f2514959.svg";